import {
  Listbox as ListboxComponent,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from "@headlessui/react";
import clsx from "clsx";
import BadgeBrainRegion from "./BadgeBrainRegion";
import Badge from "./Badge";
import { Brain, Check } from "lucide-react";

const brainRegions = [
  "Frontal",
  "Central",
  "Temporal",
  "Parietal",
  "Occipital",
];

const BrainRegionListbox = ({ value, onChange }) => {
  return (
    <ListboxComponent value={value} onChange={onChange} multiple>
      <ListboxButton
        className={clsx(
          "block rounded-lg border border-dashed border-gray-300 bg-white px-3 py-1.5 text-sm/6 text-gray-900 cursor-pointer",
          "focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:ring-opacity-50 focus:outline-none"
        )}
      >
        <div className="flex gap-2">
          <div className="flex gap-2 items-center">
            <Brain size="20" />
            Region
          </div>
          {value.length > 0 && (
            <>
              <div className="bg-gray-300 min-h-full w-px"></div>
              <div className="flex gap-1 items-center">
                {value.length > 2 ? (
                  <Badge>{value.length} selected</Badge>
                ) : (
                  value.map((value) => (
                    <BadgeBrainRegion region={value.toLowerCase()} />
                  ))
                )}
              </div>
            </>
          )}
        </div>
      </ListboxButton>
      <ListboxOptions
        anchor="bottom start"
        className="[--anchor-gap:--spacing(1)] rounded-lg border border-dashed border-gray-300 bg-white p-1"
      >
        {brainRegions.map((value) => (
          <ListboxOption
            key={value}
            value={value}
            className="group flex cursor-pointer items-center gap-2 rounded-lg px-3 py-1.5 select-none data-focus:bg-zinc-100"
          >
            <Check
              size={"16"}
              className="invisible fill-white group-data-selected:visible"
            />
            <BadgeBrainRegion region={value.toLowerCase()} />
          </ListboxOption>
        ))}
      </ListboxOptions>
    </ListboxComponent>
  );
};

export default BrainRegionListbox;
